export default __webpack_public_path__ + "static/media/licitaciones.49ba8507.svg";